<template>
  <div class="bg-membrane-gradient from-light-blue to-white h-[120%] -mt-[128px]">
    <div class="container">
      <div class="text-center text-white">
        <div class="text-9xl pt-72">
          404
        </div>
        <div class="pt-8 text-3xl opacity-60">
          The page you are looking for does not exist.
        </div>
        <router-link to="/">
          <button class="bold bg-white rounded-3xl px-4 py-2 mt-8 text-lg font-bold text-blue-primary">
            Back to Home
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>
